module.exports = __webpack_public_path__ + "static/ftrs-video-eedc8195253d6de79f233e3ee83fa767.mp4";